import { render } from "./Index.vue?vue&type=template&id=4415a7c5"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=4415a7c5&lang=css"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/sales-managment/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4415a7c5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4415a7c5', __exports__)) {
    console.log('reload')
    api.reload('4415a7c5', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=4415a7c5", () => {
    console.log('re-render')
    api.rerender('4415a7c5', render)
  })

}


export default __exports__